import { UnitConverter } from "@earthbrain/sc-earthworks";
import {
	type DistanceUnit,
	type DistanceUnitPort,
	distanceUnits,
} from "earthbrain-viewer";

const distanceUnitLabels: Record<DistanceUnit, string> = {
	[distanceUnits.METERS]: "m",
	[distanceUnits.FEET]: "ft",
	[distanceUnits.US_SURVEY_FEET]: "ft",
};

export const createDistanceUnitPort = (
	unit: DistanceUnit,
): DistanceUnitPort => ({
	unit,
	label: distanceUnitLabels[unit],
	toDisplay: (meters) =>
		UnitConverter.internalDistanceToDisplayDistance(meters, unit),
	toMeters: (displayValue) =>
		UnitConverter.displayDistanceToInternalDistance(displayValue, unit),
});
